import { t } from '../../../locales';
import { featureFlag } from '../../entities/feature-flag';

const realEstateAgentRoutes = {
	path: 'real-estate',
	component: () => import('./module-layout.vue'),
	meta: {
		featureFlag: featureFlag.REAL_ESTATE,
	},
	children: [
		{
			path: 'projects',
			component: () => import('./pages/projects/index.vue'),
			meta: {
				title: t('real-estate.projects-list'),
			},
		},
		{
			path: 'projects/add',
			component: () => import('./pages/projects/add.vue'),
			meta: {
				title: t('real-estate.add-project'),
			},
		},
		{
			path: 'projects/edit/:id',
			component: () => import('./pages/projects/add.vue'),
			meta: {
				title: t('real-estate.update-project'),
			},
		},
		{
			path: 'buildings',
			component: () => import('./pages/buildings/index.vue'),
			meta: {
				title: t('real-estate.buildings-list'),
			},
		},
		{
			path: 'buildings/add',
			component: () => import('./pages/buildings/add.vue'),
			meta: {
				title: t('real-estate.add-building'),
			},
		},
		{
			path: 'buildings/edit/:id',
			component: () => import('./pages/buildings/add.vue'),
			meta: {
				title: t('real-estate.update-building'),
			},
		},
		{
			path: 'units',
			component: () => import('./pages/units/index.vue'),
			meta: {
				title: t('real-estate.units-list'),
			},
		},
		{
			path: 'units/add',
			component: () => import('./pages/units/add.vue'),
			meta: {
				title: t('real-estate.add-unit'),
			},
		},
		{
			path: 'units/edit/:id',
			component: () => import('./pages/units/add.vue'),
			meta: {
				title: t('real-estate.update-unit'),
			},
		},
		{
			path: 'units/view/:id',
			component: () => import('./pages/units/details.vue'),
			meta: {
				title: t('real-estate.unit-details-title'),
			},
		},
		{
			path: 'reservations',
			component: () => import('./pages/reservations/index.vue'),
			meta: {
				title: t('real-estate.viewings-list'),
			},
		},
		{
			path: 'reservations/add',
			component: () => import('./pages/reservations/add.vue'),
			meta: {
				title: t('real-estate.add-viewing'),
			},
		},
		{
			path: 'reservations/edit/:id',
			component: () => import('./pages/reservations/add.vue'),
			meta: {
				title: t('real-estate.update-viewing'),
			},
		},
		{
			path: 'time-settings',
			component: () => import('./pages/time-settings/index.vue'),
			meta: {
				title: t('real-estate.operating-hours'),
			},
		},
		{
			path: 'leads',
			component: () => import('./pages/leads/index.vue'),
			meta: {
				title: t('real-estate.leads-list'),
			},
		},
		{
			path: 'unitInterests',
			component: () => import('./pages/unitInterests/index.vue'),
			meta: {
				title: t('real-estate.unit-interests-list'),
			},
		},
	],
};

export { realEstateAgentRoutes }; 